import { render } from "./AdministradoresAdmin.vue?vue&type=template&id=a382ee62"
import script from "./AdministradoresAdmin.vue?vue&type=script&lang=js"
export * from "./AdministradoresAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__